import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { useCompaniesContext } from 'company/context'
import { NewUserPhoneNumberScreenProps } from 'home/stack/types'
import { useAddEditUserContext } from 'management_team/context'
import { useUserList } from 'management_team/queries/list'
import { useCallback, useLayoutEffect, useState } from 'react'
import { showHeaderButton } from 'shared/header/header_button'
import { normalizePhoneNumber } from 'shared/utils'
import NewUserPhoneNumberView from './views'

export function NewUserPhoneNumberScreen({
  navigation,
  route,
}: NewUserPhoneNumberScreenProps) {
  const [phoneNumber, setPhoneNumber] = useState<string>()
  const [isLoading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()
  const { theme } = useTheme()
  const { handleNavigation } = useRoutingContext()
  const { activeCompany } = useCompaniesContext()
  const {
    setType,
    setPhoneNumber: setNewUserPhoneNumber,
    setUserId,
    role,
    userFields,
    setUserFields,
    setUserFieldsByUserDetails,
  } = useAddEditUserContext()
  const userListQuery = useUserList(activeCompany?.id, role)
  const onSubmit = useCallback(async () => {
    setLoading(true)
    try {
      if (phoneNumber) {
        const normalizedPhoneNumber = normalizePhoneNumber(phoneNumber)
        const existingUser = userListQuery.data?.find(
          user => user.phoneNumber === normalizedPhoneNumber
        )
        if (existingUser) {
          setUserId(existingUser.id)
          setUserFieldsByUserDetails(existingUser)
          setType('editUser')
        } else {
          setNewUserPhoneNumber(normalizedPhoneNumber)
          setType('add')
          setUserFields({ ...userFields, storeIds: [] })
        }
        if (role === 'observer') {
          handleNavigation({
            routeName: 'observer_store_chooser',
          })
        } else {
          handleNavigation({
            routeName: 'add_edit_user',
          })
        }
      }
    } catch (err: any) {
      setErrorMessage(err.message)
    } finally {
      setLoading(false)
    }
  }, [
    phoneNumber,
    userListQuery.data,
    role,
    setUserId,
    setUserFieldsByUserDetails,
    setType,
    setNewUserPhoneNumber,
    setUserFields,
    userFields,
    handleNavigation,
  ])

  useLayoutEffect(() => {
    showHeaderButton({
      navigation,
      theme,
      title: t('next'),
      onPress: () => onSubmit(),
      position: 'right',
      useIcon: false,
      disabled: !phoneNumber,
      loading: isLoading,
    })
  }, [isLoading, navigation, onSubmit, phoneNumber, theme])

  return (
    <NewUserPhoneNumberView
      phoneNumber={phoneNumber}
      setPhoneNumber={setPhoneNumber}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
    />
  )
}
